// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/BuyNow/BuyNow.css */

.buynow-wrapper {
  padding: 24px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.buynow-header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.buynow-header {
  font-size: 28px;
  font-weight: 600;
  color: #333;
}

.btn-container {
  display: flex;
  gap: 12px;
}

.bordered-button {
  background-color: #1976d2 !important;
  color: white !important;
  text-transform: none !important;
  padding: 8px 24px !important;
}

.stats-container {
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
}

.stat-card {
  padding: 24px;
  min-width: 200px;
  border-radius: 8px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.stat-card h4 {
  margin-top: 8px;
  color: #1976d2;
  font-weight: 600;
}

.filters-container {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  align-items: center;
}

.table-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.orders-table {
  width: 100%;
  border-collapse: collapse;
}

.orders-table th {
  background-color: #f8f9fa;
  padding: 8px;
  text-align: left;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #dee2e6;
  font-size: 14px;
}

.orders-table td {
  padding: 8px;
  border-bottom: 1px solid #dee2e6;
  color: #212529;
  font-size: 14px;
}

.orders-table tbody tr:hover {
  background-color: #f8f9fa;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
}

.no-data {
  text-align: center;
  padding: 48px !important;
}

.pagination {
  padding: 16px;
  border-top: 1px solid #dee2e6;
}

/* Order Details Modal */
.order-details-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  outline: none;
  padding: 24px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #dee2e6;
}

.modal-header h5 {
  margin: 0;
  color: #333;
}

.modal-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.details-section {
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.details-section h6 {
  margin-top: 0;
  margin-bottom: 16px;
  color: #495057;
  font-weight: 600;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
}

.details-grid div {
  line-height: 1.6;
}

.details-grid strong {
  color: #495057;
  margin-right: 8px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .buynow-wrapper {
    padding: 16px;
  }

  .stats-container {
    flex-direction: column;
  }

  .stat-card {
    width: 100%;
  }

  .filters-container {
    flex-direction: column;
    align-items: stretch;
  }

  .orders-table {
    display: block;
    overflow-x: auto;
  }

  .order-details-modal {
    width: 95%;
    padding: 16px;
  }

  .details-grid {
    grid-template-columns: 1fr;
  }
}

/* Status Chip Colors */
.status-chip {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
}

.status-confirmed {
  background-color: #d4edda;
  color: #155724;
}

.status-pending {
  background-color: #fff3cd;
  color: #856404;
}

.status-cancelled {
  background-color: #f8d7da;
  color: #721c24;
}

.status-processed {
  background-color: #cce5ff;
  color: #004085;
}
/* Add these styles to your existing BuyNow.css */

/* Refund button specific styles */
.refund-button {
  background-color: #ff9800 !important;
  color: white !important;
}

.refund-button:hover {
  background-color: #f57c00 !important;
}

/* Action buttons container */
.action-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
}

/* Refund dialog styles */
.MuiDialog-paper {
  padding: 8px;
}

/* Notification styles */
.MuiAlert-root {
  border-radius: 8px;
}

/* Loading state for refund button */
.refund-loading {
  opacity: 0.7;
  pointer-events: none;
}

/* Tooltip styles */
[title] {
  cursor: pointer;
}

/* Responsive styles for action buttons */
@media (max-width: 768px) {
  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/BuyNow/BuyNow.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA,iDAAiD;;AAEjD,kCAAkC;AAClC;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF","sourcesContent":["/* src/pages/BuyNow/BuyNow.css */\n\n.buynow-wrapper {\n  padding: 24px;\n  background-color: #f5f5f5;\n  min-height: 100vh;\n}\n\n.buynow-header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.buynow-header {\n  font-size: 28px;\n  font-weight: 600;\n  color: #333;\n}\n\n.btn-container {\n  display: flex;\n  gap: 12px;\n}\n\n.bordered-button {\n  background-color: #1976d2 !important;\n  color: white !important;\n  text-transform: none !important;\n  padding: 8px 24px !important;\n}\n\n.stats-container {\n  display: flex;\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n.stat-card {\n  padding: 24px;\n  min-width: 200px;\n  border-radius: 8px !important;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;\n}\n\n.stat-card h4 {\n  margin-top: 8px;\n  color: #1976d2;\n  font-weight: 600;\n}\n\n.filters-container {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n  align-items: center;\n}\n\n.table-container {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.orders-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.orders-table th {\n  background-color: #f8f9fa;\n  padding: 8px;\n  text-align: left;\n  font-weight: 600;\n  color: #495057;\n  border-bottom: 2px solid #dee2e6;\n  font-size: 14px;\n}\n\n.orders-table td {\n  padding: 8px;\n  border-bottom: 1px solid #dee2e6;\n  color: #212529;\n  font-size: 14px;\n}\n\n.orders-table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px;\n}\n\n.no-data {\n  text-align: center;\n  padding: 48px !important;\n}\n\n.pagination {\n  padding: 16px;\n  border-top: 1px solid #dee2e6;\n}\n\n/* Order Details Modal */\n.order-details-modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 90%;\n  max-width: 800px;\n  max-height: 90vh;\n  overflow-y: auto;\n  outline: none;\n  padding: 24px;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.modal-header h5 {\n  margin: 0;\n  color: #333;\n}\n\n.modal-content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.details-section {\n  padding: 16px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n}\n\n.details-section h6 {\n  margin-top: 0;\n  margin-bottom: 16px;\n  color: #495057;\n  font-weight: 600;\n}\n\n.details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 16px;\n}\n\n.details-grid div {\n  line-height: 1.6;\n}\n\n.details-grid strong {\n  color: #495057;\n  margin-right: 8px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .buynow-wrapper {\n    padding: 16px;\n  }\n\n  .stats-container {\n    flex-direction: column;\n  }\n\n  .stat-card {\n    width: 100%;\n  }\n\n  .filters-container {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .orders-table {\n    display: block;\n    overflow-x: auto;\n  }\n\n  .order-details-modal {\n    width: 95%;\n    padding: 16px;\n  }\n\n  .details-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Status Chip Colors */\n.status-chip {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.status-confirmed {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.status-pending {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.status-cancelled {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.status-processed {\n  background-color: #cce5ff;\n  color: #004085;\n}\n/* Add these styles to your existing BuyNow.css */\n\n/* Refund button specific styles */\n.refund-button {\n  background-color: #ff9800 !important;\n  color: white !important;\n}\n\n.refund-button:hover {\n  background-color: #f57c00 !important;\n}\n\n/* Action buttons container */\n.action-buttons {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n}\n\n/* Refund dialog styles */\n.MuiDialog-paper {\n  padding: 8px;\n}\n\n/* Notification styles */\n.MuiAlert-root {\n  border-radius: 8px;\n}\n\n/* Loading state for refund button */\n.refund-loading {\n  opacity: 0.7;\n  pointer-events: none;\n}\n\n/* Tooltip styles */\n[title] {\n  cursor: pointer;\n}\n\n/* Responsive styles for action buttons */\n@media (max-width: 768px) {\n  .action-buttons {\n    flex-direction: column;\n    gap: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
